import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';

export default function MemberBatchModal({ open, title, selectedIds, fields, onClose, onSaved }) {
  const [form, setForm] = useState({});
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      const initial = {};
      fields.forEach((field) => {
        initial[field.key] = field.defaultValue ?? '';
      });
      setForm(initial);
      setError('');
      setSubmitting(false);
    }
  }, [open, fields]);

  if (!open) {
    return null;
  }

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!selectedIds.length) {
      setError('請先勾選用戶');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const payload = { ids: selectedIds };
      fields.forEach((field) => {
        const value = form[field.key];
        if (value === '' || value == null) {
          return;
        }
        if (field.type === 'number' || field.type === 'select') {
          payload[field.key] = Number(value);
        } else {
          payload[field.key] = value;
        }
      });
      await adminApi.memberBatchUpdate(payload);
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err.message || '批量更新失敗');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div className="admin-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal__header">
          <h3>{title}</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <p className="page-desc">已選擇 {selectedIds.length} 位用戶</p>
            {fields.map((field) => (
              <div key={field.key} className="form-field">
                <label htmlFor={`batch-${field.key}`}>{field.label}</label>
                {field.type === 'select' ? (
                  <select
                    id={`batch-${field.key}`}
                    value={form[field.key]}
                    onChange={(e) => updateField(field.key, e.target.value)}
                    disabled={submitting}
                  >
                    {field.options.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id={`batch-${field.key}`}
                    type={field.type || 'text'}
                    value={form[field.key]}
                    onChange={(e) => updateField(field.key, e.target.value)}
                    disabled={submitting}
                  />
                )}
              </div>
            ))}
            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
